export type SendMsgPlatforms = 'EMAIL' | 'SMS';

export const SendMsgPlatformList: SendMsgPlatforms[] = ['EMAIL', 'SMS'];